import avatar1Woman from "../../assets/images/avatars/colored-avatar-female-1.jpg";
import avatar2Woman from "../../assets/images/avatars/colored-avatar-female-2.jpg";
import avatar3Woman from "../../assets/images/avatars/colored-avatar-female-3.jpg";
import avatar4Woman from "../../assets/images/avatars/colored-avatar-female-4.jpg";
import avatar5Woman from "../../assets/images/avatars/colored-avatar-female-5.jpg";
import avatar1Man from "../../assets/images/avatars/colored-avatar-male-1.jpg";
import avatar2Man from "../../assets/images/avatars/colored-avatar-male-2.jpg";
import avatar3Man from "../../assets/images/avatars/colored-avatar-male-3.jpg";
import avatar4Man from "../../assets/images/avatars/colored-avatar-male-4.jpg";

import avatarMan from "../../assets/images/male-avatar.jpg";
import avatarFemale from "../../assets/images/female-avatar.jpg";

export default class AvatarsContainer {

    constructor() {
        this.coloredAvatars = [
            {
                src: avatar1Man,
                gender: "Male"
            },
            {
                src: avatar2Man,
                gender: "Male"
            },
            {
                src: avatar3Man,
                gender: "Male"
            },
            {
                src: avatar4Man,
                gender: "Male"
            },
            {
                src: avatar1Woman,
                gender: "Female"
            },
            {
                src: avatar2Woman,
                gender: "Female"
            },
            {
                src: avatar3Woman,
                gender: "Female"
            },
            {
                src: avatar4Woman,
                gender: "Female"
            },
            {
                src: avatar5Woman,
                gender: "Female"
            }
        ]
        this.avatars = [
            {
                src: avatarMan,
                gender: "Male"
            },
            {
                src: avatarFemale,
                gender: "Female"
            }
        ];
    }

    getRandomAvatar(){
        const self = this;
        return self.avatars[Math.floor(Math.random() * self.avatars.length)];
    }

    getRandomAvatarWithGender(gender){
        const avatarsWithGender = this.avatars.filter(avatar => avatar.gender === gender);
        return avatarsWithGender[Math.floor(Math.random() * avatarsWithGender.length)];
    }
}